import httpManager from "../../../shared/utils/httpManager";

/**
 * Obtener cantidad de estados de contactos.
 *
 * @param {Array<Number>} ids
 * @return {Promise<Object>} Cantidad de estados
 */
export async function fetchContactsStatus(ids) {
  const url = `/contacts/clients/status/`;
  const response = await httpManager.post(url, { client_ids: ids });
  return response.data;
}
